import * as React from 'react';

import DocumentCreationButton from '../../../components/DocumentCreationButton';
import DocumentHeader from '../../../components/DocumentHeader';
import DocumentWrapper from '../../../components/DocumentWrapper';
import FormEditingHandler from '../../../containers/FormEditingHandler';

import NutritionForm from './Form';
import { EditHistoryDialogStandAlone } from 'Components/HistoryRowControls/EditHistory/EditHistoryDialog';

const Nutrition = ({ documents }: IOwnProps): React.JSX.Element => (
  <FormEditingHandler name="nutrition" documents={documents}>
    {(editing, startEdit, formData): React.JSX.Element => {
      const nutritionDocument = documents?.length > 0 ? documents[0] : undefined;
      return (
        <DocumentWrapper>
          <DocumentHeader
            name={'nutrition'}
            headerId={'nutrition.title'}
            editing={editing}
            editButtons={[
              <DocumentCreationButton
                key={'creation'}
                name={'nutrition'}
                document={nutritionDocument}
                text={'general.edit'}
                onClick={startEdit(documents?.length > 0 ? { _id: documents[0]._id } : { _id: undefined })}
              />,
              <EditHistoryDialogStandAlone key={'edit'} document={nutritionDocument} />,
            ]}
          />
          <NutritionForm editing={editing} formData={formData} document={documents?.[0]} />
        </DocumentWrapper>
      );
    }}
  </FormEditingHandler>
);

interface IOwnProps {
  documents: INutrition[];
}

export default Nutrition;
